import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { observer } from 'mobx-react-lite';
import i18n from '../../i18n';
import { ReactComponent as CardViewIcon } from '../../static/images/svg/auto_stories.svg';
import { ReactComponent as TableViewIcon } from '../../static/images/svg/material-symbols_menu-book-outline.svg';
import riskOrderListState, { RiskOrderListViewMode } from './risk-order-list-state';

/** 与导出按钮 SVG 一致的可点击区域尺寸 */
const VIEW_MODE_ICON_SX = { width: 40, height: 40, display: 'block' } as const;

type ViewModeOption = {
    /** 模式值 */
    value: RiskOrderListViewMode;
    /** Tooltip / aria-label 文案 key */
    titleKey: string;
    /** 图标 */
    icon: React.ReactNode;
};

const VIEW_MODE_OPTIONS: ViewModeOption[] = [
    {
        value: 'card',
        titleKey: 'intelligent_risk_control_page_view_card_mode',
        icon: <CardViewIcon style={VIEW_MODE_ICON_SX} />,
    },
    {
        value: 'table',
        titleKey: 'intelligent_risk_control_page_view_table_mode',
        icon: <TableViewIcon style={VIEW_MODE_ICON_SX} />,
    },
];

/**
 * 即时风险订单列表：卡片 / 表格视图切换（仅展示当前激活模式图标，点击切到另一模式）
 */
const RiskOrderViewModeIconButtons = observer(() => {
    const currentMode = riskOrderListState.viewMode;
    const activeOption = VIEW_MODE_OPTIONS.find((option) => option.value === currentMode);
    const nextMode: RiskOrderListViewMode = currentMode === 'card' ? 'table' : 'card';
    const nextOption = VIEW_MODE_OPTIONS.find((option) => option.value === nextMode);

    if (!activeOption || !nextOption) {
        return null;
    }

    const activeTitle = i18n.t(activeOption.titleKey);
    const switchTitle = i18n.t(nextOption.titleKey);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title={`${activeTitle} · ${switchTitle}`} placement="top">
                <span>
                    <IconButton
                        color="primary"
                        aria-label={`${activeTitle}，${switchTitle}`}
                        aria-pressed
                        onClick={() => riskOrderListState.setViewMode(nextMode)}
                        sx={{ p: 0 }}
                    >
                        {activeOption.icon}
                    </IconButton>
                </span>
            </Tooltip>
        </Box>
    );
});

export default RiskOrderViewModeIconButtons;
